// src/features/articles/articlesSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

// Thunks for fetching data
export const fetchArgentinianHeadlines = createAsyncThunk(
  'articles/fetchArgentinianHeadlines',
  async (_, { rejectWithValue }) => {
    let retries = 0;
    const maxRetries = 10;
    const authors = [
      'Perfil', 'Página 12', 'Infonews', 'La Nación', 'Infobae',
      'Data 24', 'Minuto Uno', 'Chequeado', 'El Cronista', 'IProfesional'
    ];

    while (retries < maxRetries) {
      try {
        const shuffledAuthors = authors.sort(() => Math.random() - 0.5);
        const randomAuthors = shuffledAuthors.slice(0, 3);

        const response = await axios.get('https://existence-server.vercel.app/headlines');
        const headlinesByRandomAuthors = response.data
          .reverse()
          .filter(headline => randomAuthors.includes(headline.author))
          .reduce((uniqueHeadlines, headline) => {
            if (!uniqueHeadlines.some(a => a.author === headline.author)) {
              uniqueHeadlines.push(headline);
            }
            return uniqueHeadlines;
          }, [])
          .slice(0, 3);

        return headlinesByRandomAuthors;
      } catch (error) {
        retries++;
        if (retries >= maxRetries) {
          return rejectWithValue('Failed to fetch headlines after multiple attempts.');
        }
      }
    }
  }
);

export const fetchArgentinianArticles = createAsyncThunk(
  'articles/fetchArgentinianArticles',
  async (_, { rejectWithValue }) => {
    let retries = 0;
    const maxRetries = 10;

    while (retries < maxRetries) {
      try {
        const response = await axios.get('https://existence-server.vercel.app/articles');
        return response.data;
      } catch (error) {
        retries++;
        if (retries >= maxRetries) {
          return rejectWithValue('Failed to fetch articles after multiple attempts.');
        }
      }
    }
  }
);

// Articles slice
const articlesSlice = createSlice({
  name: 'articles',
  initialState: {
    argentinianHeadlines: [],
    argentinianHeadlineLoading: true,
    argentinianHeadlineError: null,
    argentinianArticles: [],
    argentinianArticleLoading: true,
    argentinianArticleError: null,
    favArticles: []
  },
  reducers: {
    setFavArticles: (state, action) => {
      state.favArticles = action.payload;
      localStorage.setItem('favArticles', JSON.stringify(state.favArticles));
    },
    loadFavArticles: (state) => {
      const storedFavArticles = localStorage.getItem('favArticles');
      if (storedFavArticles) {
        state.favArticles = JSON.parse(storedFavArticles);
      }
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchArgentinianHeadlines.pending, (state) => {
        state.argentinianHeadlineLoading = true;
        state.argentinianHeadlineError = null;
      })
      .addCase(fetchArgentinianHeadlines.fulfilled, (state, action) => {
        state.argentinianHeadlines = action.payload;
        state.argentinianHeadlineLoading = false;
      })
      .addCase(fetchArgentinianHeadlines.rejected, (state, action) => {
        state.argentinianHeadlineLoading = false;
        state.argentinianHeadlineError = action.payload;
      })
      .addCase(fetchArgentinianArticles.pending, (state) => {
        state.argentinianArticleLoading = true;
        state.argentinianArticleError = null;
      })
      .addCase(fetchArgentinianArticles.fulfilled, (state, action) => {
        state.argentinianArticles = action.payload;
        state.argentinianArticleLoading = false;
      })
      .addCase(fetchArgentinianArticles.rejected, (state, action) => {
        state.argentinianArticleLoading = false;
        state.argentinianArticleError = action.payload;
      });
  }
});

export const { setFavArticles, loadFavArticles } = articlesSlice.actions;

const articlesReducer = articlesSlice.reducer;

export default articlesReducer;

